import React from 'react';
import cx from 'classnames';
import { TrainingJobCell } from 'src/components/TrainingJobCell';
import moment from 'moment/moment';
import { ClientSideTable } from 'src/components/ClientSideTable';

export const JobDetailPane = ({
  job,
  noSelectedJobText,
}: {
  job:
    | {
        id: string;
        trainingJobArn?: string;
        trainingJobName?: string;
        createdDate?: string;
        metrics: Metric[];
      }
    | undefined;
  noSelectedJobText: string;
}) => (
  <div
    className={cx('job-detail-pane', {
      'job-detail-pane--empty': !job,
    })}
  >
    {!job && <p>{noSelectedJobText}</p>}
    {job && (
      <div className="job-detail-pane__layout">
        <div className="job-detail-pane__info-cell">
          <label className="font-bold">Training Job</label>
          {job.trainingJobArn && job.trainingJobName ? (
            <div>
              <TrainingJobCell
                trainingJobArn={job.trainingJobArn}
                trainingJobName={job.trainingJobName}
                id={job.id}
              />
            </div>
          ) : (
            <p>{job.id}</p>
          )}
        </div>
        <div className="job-detail-pane__info-cell">
          {job.createdDate && (
            <>
              <label className="font-bold">Created Date</label>
              <p
                className="job-detail-pane__create-date"
                title={moment.unix(parseInt(job.createdDate)).toString()}
              >
                {moment.unix(parseInt(job.createdDate)).fromNow()}
              </p>
            </>
          )}
        </div>

        {job.metrics && (
          <div className="job-detail-pane__info-cell">
            <ClientSideTable
              filteringDisabled
              preferencesDisabled
              title="Metrics"
              columnDefinitions={[
                {
                  header: 'Name',
                  id: 'MetricName',
                  cell: (item) => item.MetricName,
                },
                {
                  header: 'Value',
                  id: 'Value',
                  cell: (item) => {
                    const parsedValue: number = parseFloat(item.Value);
                    if (isNaN(parsedValue)) return <span>{item.Value}</span>;
                    return (
                      <span title={item.Value}>
                        {parseFloat(item.Value).toFixed(4)}
                      </span>
                    );
                  },
                },
              ]}
              data={job.metrics}
              error={null}
            />
          </div>
        )}
      </div>
    )}
  </div>
);
